import { LabelProps } from 'recharts';

export const ContributingOutcomesChartLabels = (props: LabelProps) => {
  const { x, y, width, value } = props;

  if (value == null || Number(value) === 0) {
    return null;
  }

  return (
    <text
      x={x != null && width != null ? Number(x) + Number(width) / 2 : undefined}
      y={y != null ? Number(y) - 5 : undefined}
      fill="#333"
      textAnchor="middle"
      fontSize={10}
      fontWeight="500"
    >
      {Number(value)}
    </text>
  );
};
